export const initOptionDateLocale = {
  altInput: true,
  altFormat: "d/m/Y H:i:S",
  dateFormat: "d/m/Y H:i:S",
  allowInput: true,
  // shorthandCurrentMonth:true,
  locale: {
    firstDayOfWeek: 1,
  },
};

export const MODE_FORM = {
  ADD: "add",
  EDIT: "edit",
  VIEW: "view",
};

export const convertDate = data => {
  const type = typeof data;
  let date = null;
  if (type === "object") {
    date = Math.round(new Date(data).getTime() / 1000);
  } else {
    date = data;
  }
  return date;
};

export const formatTimestampToDate = timestamp => {
  const date = new Date(Number(timestamp) * 1000);
  return date;
};

export const tableFormateDate = (data, isSecond = false, isDMYOnly = false) => {
  if (new Date(Number(data)).toString() !== "Invalid Date") {
    if (isDMYOnly) {
      return Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(data * 1000);
    } else if (isSecond) {
      return Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "numeric",
      }).format(data * 1000);
    } else {
      return Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      }).format(data * 1000);
    }
  }
  return "";
};
